exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trick {\n  width: 100%;\n  margin: auto;\n  text-align: center; }\n\n#inp {\n  text-align: center;\n  margin: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jmiller/Projects/Real/j-trip/j-trip/src/app/add-moment/add-moment.component.scss
// module id = ../../../../../src/app/add-moment/add-moment.component.scss
// module chunks = main